<template>
  <v-expansion-panel >
    <v-expansion-panel-header class="py-0" min-height="20"  >
      <v-row class="no-gutters">
        <v-col cols="12" class="d-flex justify-space-between align-center text-primary">
          <div class="mr-2 text-medium mr-auto">{{ oDataExpander.titulo}}</div>
          <div class="ml-auto">{{oDataExpander.acciones}} {{oDataExpander.subtitulo}}</div>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pa-0 ma-0 cont-exp">
      <grid ref="GridPrincipal"
        v-if="this.$store.state.token!=''"
        :key="nRefresGrid"
        :tabla="aTablaName"
        :bActiveFilter="true"
        :bActiveExport="false"
        :bSingleSelect="false"
        :bShowSelect="false"
        :sIdTable="aIdTable"
        :bShowMapDetails="false"
        :bActiveNew="false"
        :cabeceraVisible="false"
        altoTabla="48vh"
        :aParametros="[`idPerfil=${sIdPerfil}`]"
        @onCambioInfo="onCambioInfo"
        >
      </grid>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import grid from '@/components/Grid/Grid.vue'
export default {
  name:"perfilExpander",
  components: {
    grid
  },
  props:{
    oDataExpander: {
      type: Object,
      default: () => {}
    },
    sIdPerfil: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      nTabSelect : 0,
      aTablaName  : 'PQR_Perfiles_Acciones',
      aIdTable    : 'idPQR_Perfil,idEstado_Requerimiento',
      nRefresGrid : 0,
      panels: null,
      bLoad: false,
      aHeaders:[
        {text: 'Privilegios', align: 'start',  sortable: false,  value: 'privilegio'},
        {text: 'Activo', align: 'center',  sortable: false,  value: 'activo'},
      ],
      aParametrosAdicionalesObs:[
        "", //Pendiente
      ],
    }
  },
  methods: {
    onCambioInfo (sTipo, bValor){
     bValor
      if(sTipo === 'campoSwitch') {
        this.$emit('onActualizar', this.sIdPerfil)
      }
    }
  },
  watch: {
    onCambiarValor(){
      this.bLoad = true
      setTimeout(() => {
        this.bLoad = false
      }, 2000);
    }
  },
}
</script>
<style lang="scss">
.cont-exp {
  .v-expansion-panel-content__wrap{
    padding:0px!important;
  }
} 
.cont-sw{
  width: 100px;
  margin: 0;
  padding: 0;
}

</style>